// src/lib/updateUser.ts
import axios from 'axios';
import { parseCookies } from 'nookies';
import { toast } from '@/hooks/use-toast';

export type UpdateInput = { fullName: string; email: string };
export type UpdateResponse = { success: boolean; data: any; message: string; error?: any };

export const updateUser = async (
    { fullName, email }: UpdateInput,
    { silentSuccess = false }: { silentSuccess?: boolean } = {},
): Promise<UpdateResponse | null> => {
    const cookies = parseCookies();
    const token = cookies.user_auth_token;

    if (!token) {
        toast({
            className: 'bg-red-600 text-white rounded-2xl',
            title: 'احراز هویت انجام نشد. لطفاً دوباره وارد شوید.',
        });
        return null;
    }

    try {
        const response = await axios.post<UpdateResponse>(
            '/api/auth/update',
            { fullName, email, token },
            { headers: { 'Content-Type': 'application/json' } },
        );

        const data = response.data;

        // ✅ Success branch
        if (!silentSuccess) {
            toast({
                className: 'bg-green-600 text-white rounded-2xl',
                title: 'بروزرسانی با موفقیت انجام شد',
            });
        }

        return data;
    } catch (err: any) {
        const data = err?.response?.data as UpdateResponse | undefined;
        const message = data?.message || err?.message;

        if (message === 'email_taken' || message === 'validation.unique') {
            toast({
                className: 'bg-red-600 text-white rounded-2xl',
                title: 'این ایمیل قبلاً ثبت شده است.',
            });
        } else {
            toast({
                className: 'bg-red-600 text-white rounded-2xl',
                title: message || 'خطا در بروزرسانی',
            });
        }

        console.warn('Update user failed:', data || err.message);
        return null;
    }
};
